import service from './service'

import config from './config'

const { defaultHeaders } = config

const request = (option) => {
  const { url, method, params, data, headersType, responseType } = option

  return service.request({
    url: url,
    method,
    params,
    data,
    responseType: responseType,
    headers: {
      'Content-Type': headersType || defaultHeaders
    }
  })
}

const axiosObject = {
  get: (option) => {
    return request({ method: 'get', ...option })
  },
  post: (option) => {
    return request({ method: 'post', ...option })
  },
  delete: (option) => {
    return request({ method: 'delete', ...option })
  },
  put: (option) => {
    return request({ method: 'put', ...option })
  },
  patch: (option) => {
    return request({ method: 'patch', ...option })
  },
  cancelRequest: (url) => {
    return service.cancelRequest(url)
  },
  cancelAllRequest: () => {
    return service.cancelAllRequest()
  }
}

export default axiosObject